'use strict';

exports.__esModule = true;
exports.createConnector = exports.connectors = undefined;

var _class, _temp, _initialiseProps;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _query = require('../query');

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

var _ContractSource = require('../View/ContractSource');

var _ContractSource2 = _interopRequireDefault(_ContractSource);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var connectors = exports.connectors = [{
  code: _query.ethContractSource
}, {
  code: _query.updateEthContractSourceProcessor // name: "updateEthContractSourceProcessor",

}];

var createConnector = function createConnector(connectors) {
  return _reactApollo.compose.apply(this, connectors.map(function (n) {
    var code = n.code,
        other = _objectWithoutProperties(n, ['code']);

    return (0, _reactApollo.graphql)((0, _graphqlTag2.default)(code), _extends({}, other));
  })); // const code = ethContractSourcesConnection;
  // return compose(
  //   [graphql(gql(code))],
  // );
};

exports.createConnector = createConnector;
var ContractSourcePage = (_temp = _class = function (_Page) {
  _inherits(ContractSourcePage, _Page);

  function ContractSourcePage(props) {
    _classCallCheck(this, ContractSourcePage);

    var _this = _possibleConstructorReturn(this, _Page.call(this, props));

    _initialiseProps.call(_this);

    var connectors = props.connectors,
        View = props.View;
    Object.assign(_this.state, {
      Connector: createConnector(connectors)(View)
    });
    return _this;
  }

  ContractSourcePage.prototype.render = function render() {
    var _this2 = this;

    var Connector = this.state.Connector;

    var _props = this.props,
        contractSourceId = _props.match.params.contractSourceId,
        other = _objectWithoutProperties(_props, ['match']); // return null;


    return _Page.prototype.render.call(this, _react2.default.createElement(Connector, _extends({
      where: {
        id: contractSourceId
      },
      onSave: this.onSave ? function (result) {
        return _this2.onSave(result);
      } : undefined
    }, other)));
  };

  return ContractSourcePage;
}(_layout2.default), _class.defaultProps = _extends({}, _layout2.default.defaultProps, {
  connectors: connectors,
  View: _ContractSource2.default
}), _initialiseProps = function _initialiseProps() {
  this.state = {};
}, _temp);
exports.default = ContractSourcePage;